import { Gender } from "../interfaces/enums/Gender";
import { SmokerStatus } from "../interfaces/enums/SmokerStatus";
import { IClient } from "../interfaces/IClient";

const MAX_ADULTS = 2;

export function getClientNumberDisplay(
    index: number,
    clients: IClient[],
    client: IClient
): number {
    const numberOfAdults = clients.filter((i) => !i.isChild).length;

    return (client.isChild ? index - numberOfAdults : index) + 1;
}

export function sortClientsForAdult(a: IClient, b: IClient): number {
    return a.isChild === b.isChild ? 0 : a.isChild ? 1 : -1; // Adults first
}

export function generateClientDetailSummaryString(clients: IClient[]): string {
    const childCount = clients.filter((c) => c.isChild && c.gender !== Gender.Unknown)
        .length;

    let res = clients
        .filter(
            (c) =>
                !c.isChild &&
                c.gender !== Gender.Unknown &&
                c.smokerStatus !== SmokerStatus.Unknown
        )
        .map(
            (client) =>
                `${client.gender} (${client.age}, ${client.smokerStatus.toLowerCase()})`
        )
        .join("; ");

    if (childCount > 0) {
        res += `; Children (${childCount})`;
    }

    return res;
}

export function getSmokingStatusText(smokerStatus: SmokerStatus): string {
    switch (smokerStatus) {
        case SmokerStatus.Smoker:
            return "Smoker";
        case SmokerStatus.NonSmoker:
            // This string uses the special, non-break hyphen character
            // Otherwise by default, when breaking on word, it will break on the hyphen
            return "Non‑smoker";
        case SmokerStatus.Unknown:
        default:
            return "Unknown";
    }
}

export function generateClientSettingsSummaryString(client: IClient): string {
    return client.isChild ? `${client.gender}` : `${client.gender}, ${client.age}`;
}

export function generateClientApplyResultString(
    client: IClient
    // setting: QuoteSettingContainerType,
    // isBasicOnly = false
): string {
    let res = `${client.age} year old ${client.gender.toLowerCase()}`;

    if (!client.isChild) {
        res += ` ${getSmokingStatusText(client.smokerStatus).toLowerCase()}`;
    }

    if (client.isChild) {
        res = `${client.gender.toLowerCase()} child`;
        res = res.charAt(0).toUpperCase() + res.slice(1);
    }

    // if (
    //     !isBasicOnly &&
    //     (setting.productType === ProductType.Income ||
    //         setting.productType === ProductType.Mortgage)
    // ) {
    //     const settingsIncome = setting.clients.find(
    //         (c) => c.personId === client.personId
    //     );
    //     if (settingsIncome) {
    //         res += ` (Occupation Class ${
    //             settingsIncome.occupationClass
    //         } - ${getEmploymentTypeAsString(settingsIncome.employmentType)})`;
    //     }
    // }

    return res;
}

export function getAdults(clients: IClient[]): IClient[] {
    return clients.filter((i) => !i.isChild);
}

export function getChildren(clients: IClient[]): IClient[] {
    return clients.filter((i) => i.isChild);
}

export function numberOfAdults(clients: IClient[]): number {
    return getAdults(clients).length;
}

export function numberOfChildren(clients: IClient[]): number {
    return getChildren(clients).length;
}

export function canAddAdult(clients: IClient[]): boolean {
    return numberOfAdults(clients) < MAX_ADULTS;
}

export function canAddChildren(clients: IClient[]): boolean {
    return numberOfChildren(clients) < 1;
}

export function canDeleteClient(clients: IClient[]): boolean {
    return getAdults(clients).length > 1;
}
